import { mdiChevronLeft, mdiChevronRight, mdiTranslate } from '@mdi/js'
import Icon from '@mdi/react'
import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { HStack, Stack } from '@/components/ui/stack'
import { Text } from '@/components/ui/typography'
import { currentEnv } from '@/env/vars'
import MultiSelect from '@/pages/components/translate/leftSide/components/multiSelect'
import { translateLeftSideExpandedAtom } from '@/store/translate'

import ActionButtons from '../../conversationList/components/actionButtons'
import DropZone from './components/dropzone/'
import GlossarySelect from './components/glossarySelect'
import SectionDescription from './components/sectionDescription'
import UploadedFiles from './components/uploadedFiles'
import UploadingTranslateDocuments from './components/uploadingTranslationDocuments'

const LeftSide = () => {
    const { t } = useTranslation()
    const [showSidebar, setShowSidebar] = useAtom(translateLeftSideExpandedAtom)

    const toggleSidebar = () => {
        setShowSidebar(!showSidebar)
    }

    return (
        <Box h="100%" position="relative">
            <Box
                height="100%"
                py="24px"
                pr={['0', '0', '30px']}
                pl={['0', '0', showSidebar ? '24px' : '0']}
                width="100%"
                position="relative"
            >
                <Box height="100%" width="100%" display={showSidebar ? 'block' : 'none'}>
                    <Stack height="calc(100%)" minH="300px">
                        <HStack justifyContent="space-between">
                            <Text
                                fontSize="21px"
                                fontFamily="GSKPrecision-Bold"
                                fontWeight="bold"
                                letterSpacing="0.25px"
                                display="flex"
                                lineHeight="16px"
                            >
                                <Icon
                                    path={mdiTranslate}
                                    size="20px"
                                    color="var(--chakra-colors-gray-800)"
                                    style={{
                                        marginRight: '18px',
                                    }}
                                />
                                {t('chat.translate.leftSectionTitle')}
                            </Text>
                            <ActionButtons processingStrategy="Translation" />
                        </HStack>

                        <SectionDescription />
                        <MultiSelect />
                        <DropZone />
                        <UploadingTranslateDocuments />
                        {currentEnv.features.isEnabled('glossaries') && <GlossarySelect />}
                        <UploadedFiles />
                    </Stack>
                </Box>
                <Flex
                    position="absolute"
                    top="0"
                    right="0"
                    flexDir="column"
                    height="100%"
                    justifyContent="center"
                    cursor="pointer"
                    onClick={toggleSidebar}
                    width="30px"
                    alignItems="center"
                >
                    <Icon path={showSidebar ? mdiChevronLeft : mdiChevronRight} size={1} />
                </Flex>
            </Box>
        </Box>
    )
}

export default LeftSide
